<template>
  <donut :chartdata="chartdata" :options="chartOptions" v-bind="$attrs" />
</template>

<script>
  import Donut from 'components/Charts/Donut.vue'
  import { merge } from 'lodash'
  import { secondsToHumanReadable } from 'src/utils/format'

  export default {
    components: {
      Donut
    },
    props: {
      projectSecondsStatisticsData: {
        type: Array,
        required: true
      },
      options: {
        type: Object,
        required: false,
        default: null
      }
    },
    computed: {
      chartdata () {
        return {
          labels: this.projectSecondsStatisticsData.map(project => (project.project_name || this.$t('without_project')).substring(0, 50)),
          datasets: [
            {
              data: this.projectSecondsStatisticsData.map(project => project.value)
            }
          ]
        }
      },
      chartOptions () {
        return merge({}, this.options, {
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                return `${secondsToHumanReadable(data['datasets'][0]['data'][tooltipItem['index']])} h`
              }
            }
          }
        })
      }
    }
  }
</script>
